import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card } from "../components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Tags } from "lucide-react";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState("");

  const load = () => api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setName(""); setOpen(true); };
  const openEdit = (c) => { setEditing(c); setName(c.name); setOpen(true); };

  const save = async () => {
    if (!name.trim()) return;
    try {
      if (editing) await api.put(`/categories/${editing.id}`, { name });
      else await api.post("/categories", { name });
      toast.success("Kategori disimpan"); setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const remove = async (c) => {
    try { await api.delete(`/categories/${c.id}`); toast.success("Kategori dihapus"); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-5" data-testid="categories-page">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight">Kategori Produk</h1>
          <p className="text-muted-foreground text-sm">Kelompokkan produk agar lebih mudah dicari.</p>
        </div>
        <Button onClick={openNew} className="rounded-lg" data-testid="add-category-btn"><Plus className="w-4 h-4 mr-1" /> Tambah</Button>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cats.map((c) => (
          <Card key={c.id} className="p-4 border-slate-200 rounded-xl shadow-sm flex items-center gap-3" data-testid={`category-${c.id}`}>
            <div className="w-10 h-10 rounded-lg bg-accent text-primary flex items-center justify-center"><Tags className="w-5 h-5" /></div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold truncate">{c.name}</div>
              <div className="text-xs text-muted-foreground">{c.product_count} produk</div>
            </div>
            <button onClick={() => openEdit(c)} className="text-slate-400 hover:text-primary p-1"><Pencil className="w-4 h-4" /></button>
            <button onClick={() => remove(c)} className="text-slate-400 hover:text-red-600 p-1" data-testid={`delete-category-${c.id}`}><Trash2 className="w-4 h-4" /></button>
          </Card>
        ))}
        {cats.length === 0 && <div className="col-span-full text-center py-12 text-muted-foreground">Belum ada kategori.</div>}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="category-dialog">
          <DialogHeader><DialogTitle className="font-heading">{editing ? "Edit Kategori" : "Tambah Kategori"}</DialogTitle></DialogHeader>
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nama kategori" className="rounded-lg" data-testid="category-name-input" />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} className="rounded-lg">Batal</Button>
            <Button onClick={save} className="rounded-lg" data-testid="save-category-btn">Simpan</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
